module.exports = __webpack_public_path__ + "img/calendario_prezzi_orari.61944e8c.svg";